import { useEffect, useState } from 'react';
import './App.css';
import Aside from './Common/Aside';
import Header from './Common/Header';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from './Pages/Dashboard';
import Users from './Pages/Users';
import LogsHistory from './Pages/LogsHistory';
import Accounts from './Pages/Accounts';
import {useDispatch, useSelector} from 'react-redux';
import Login from './Pages/Login';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { usersActions } from './store/user';
import ActionsHistory from './Pages/ActionsHistory';
import WonCars from './Pages/WonCars';
import Alerts from './Pages/Alerts';
import Notifications from './Pages/Notifications';
import WatchList from './Pages/WatchList';

function App() {
  const [showFullWidth, setShowFullWidth] = useState(true);
  const user = useSelector((state) => state.user);
  const [notification, setNotification] = useState({type: "", text: "", show: false});
  const dispatch = useDispatch();

  useEffect(() => {
    axios('/api/extension/v1/logged-in-user')
      .then((res) => {
        dispatch(usersActions.changeIsLoggedIn(true));
        dispatch(usersActions.saveUserData(res.data.data));
      })
      .catch(() => {
        dispatch(usersActions.changeIsLoggedIn(false));
      })
  }, [])

  return (
    <div className="root">
      {notification.show && <Alert style={{position: "absolute", zIndex: "1111", bottom: "20px"}} severity={notification.type}>
          {notification.text}
      </Alert>}
      { (user.isLoggedIn == true && user.role != "user") && <>
        <div className={`aside-container ${showFullWidth ? '' : "minimized-aside-container"}`}>
          <Aside showFullWidth={showFullWidth} />
        </div>
        <div className={`website-main-content ${showFullWidth ? "" : "website-main-content-minimized-aside"}`}>
          <Header setNotification={setNotification} setShowFullWidth={setShowFullWidth} />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/users" element={<Users setNotification={setNotification} />} />
            <Route path="/accounts" element={<Accounts setNotification={setNotification} />} />
            <Route path="/bids-history" element={<LogsHistory setNotification={setNotification} />} />
            <Route path="/actions-history" element={<ActionsHistory setNotification={setNotification} />} />
            <Route path="/won-vehicles" element={<WonCars setNotification={setNotification} />} />
            <Route path="/watchlist" element={<WatchList setNotification={setNotification} />} />
            {user.role == "admin" && <Route path="/alerts" element={<Alerts setNotification={setNotification} />} />}
            {user.role == "admin" && <Route path="/notifications" element={<Notifications setNotification={setNotification} />} />}
          </Routes>
        </div>
      </>}
      {
        user.isLoggedIn == false && <Login setNotification={setNotification} />
      }
    </div>
  );
}

export default App;
